var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgUpload = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 104,
    viewBox: "0 0 102 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.4741 88.9741H6.47412C3.35751 88.9741 0.974121 86.5907 0.974121 83.4741V6.47412C0.974121 3.35751 3.35751 0.974121 6.47412 0.974121H68.0741L88.9741 21.8741V83.4741C88.9741 86.5907 86.5907 88.9741 83.4741 88.9741Z",
    fill: "#4C576F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0741 0.974022L88.9741 21.874H68.0741V0.974022Z",
    fill: "#BACACE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40747 79.9907V54.8741V41.6741V18.9407H55.6075V20.7741H32.1407C31.5907 32.1407 22.6073 41.3075 11.2407 41.6741V54.8741H34.5241V78.1575H49.5575V49.5575H39.4741V47.7241H51.2075V78.1575H68.4409V67.7075H60.7409V65.8741H68.4409V35.2575H70.2741V79.9907H9.40747ZM30.3075 20.9575H11.2407V40.0241C21.5075 39.4741 29.9407 31.2241 30.3075 20.9575ZM32.6907 56.8907H11.2407V78.1575H32.6907V56.8907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0907 70.8241V72.6575H74.3075V70.8241H76.6907V50.4741H74.3075V48.6407H76.6907V28.2907H74.3075V26.4575H81.0907V28.2907H78.5241V48.6407H81.0907V50.4741H78.5241V70.8241H81.0907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2907 13.6242H40.9407V16.0076H39.1074V13.6242H18.5741V16.0076H16.7407V9.40756H18.5741V11.7908H39.1074V9.40756H40.9407V11.7908H61.2907V9.40756H63.1241V16.0076H61.2907V13.6242Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100.526 84C100.526 94.2316 92.2316 102.526 82 102.526C71.7685 102.526 63.4741 94.2316 63.4741 84C63.4741 73.7685 71.7685 65.4741 82 65.4741C92.2316 65.4741 100.526 73.7685 100.526 84Z",
    fill: "white",
    stroke: "#EAEEF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2254 75.1474C79.2254 73.5619 80.4145 72.3728 82 72.3728C83.4534 72.3728 84.7746 73.5619 84.7746 75.1474V93.1163C84.7746 94.7018 83.5855 95.891 82 95.891C80.4145 95.891 79.2254 94.7018 79.2254 93.1163V75.1474Z",
    fill: "#235EFB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0181 76.9972C78.9612 75.9402 78.9612 74.2225 80.0181 73.1655C81.0751 72.1086 82.7928 72.1086 83.8498 73.1655L90.1917 79.5075C91.2487 80.5645 91.2487 82.2821 90.1917 83.3391C89.1347 84.3961 87.4171 84.3961 86.3601 83.3391L80.0181 76.9972Z",
    fill: "#235EFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0182 73.1655C81.0752 72.1086 82.7928 72.1086 83.8498 73.1655C84.9068 74.2225 84.9068 75.9402 83.8498 76.9972L77.6399 83.3391C76.5829 84.3961 74.8653 84.3961 73.8083 83.3391C72.7513 82.2821 72.7513 80.5645 73.8083 79.5075L80.0182 73.1655Z",
    fill: "#235EFB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 88,
    fill: "white",
    transform: "matrix(1 0 0 -1 0.974121 88.9741)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUpload);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/upload.ab3eceb241255158c647666106278c5f.svg";